import {MithrilComponent} from '@bitstillery/mithril'
import {CURRENCY_SYMBOLS, format_money_responsive} from '@bitstillery/common/lib/format'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

import {$s} from '@/app'
import {offer_item_price} from '@/lib/price'

import type {CartOfferItem} from '@/models/cart'

interface OfferItemAmountAttrs {
    currency: string
    offer_item: CartOfferItem
    /** A raised price comes through as the cart error's `valid_value`, which the API sends as a string. */
    value: number | string
}

/**
 * This is a regular price. OfferItems with type offer/spotlight
 * use the Changed component.
 */
export class OfferItemAmount extends MithrilComponent<OfferItemAmountAttrs> {
    view(vnode: m.Vnode<OfferItemAmountAttrs>) {
        const {offer_item} = vnode.attrs
        const price_info = offer_item_price(offer_item, $s.cart.errors)
        const currency_symbol = CURRENCY_SYMBOLS[vnode.attrs.currency]

        return (
            <span className={classes('c-offer-item-amount', 'c-changed', price_info.is_down ? 'type-brand' : '')}>
                {price_info.is_down && <span className={'previous'}>{format_money_responsive(price_info.previous)}</span>}
                <span className={'current'}>
                    {currency_symbol !== undefined && `${currency_symbol} `}
                    {format_money_responsive(Number(vnode.attrs.value))}
                </span>
            </span>
        )
    }
}
